/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_RegenerateInputs */

const en_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate`)
};

const de_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu generieren`)
};

const fr_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régénérer`)
};

const es_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerar`)
};

const it_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rigenera`)
};

const nl_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw genereren`)
};

const pl_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygeneruj ponownie`)
};

const fi_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo uudelleen`)
};

const da_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer igen`)
};

const sv_salary_negotiate_regenerate = /** @type {(inputs: Salary_Negotiate_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera om`)
};

/**
* | output |
* | --- |
* | "Regenerate" |
*
* @param {Salary_Negotiate_RegenerateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_regenerate = /** @type {((inputs?: Salary_Negotiate_RegenerateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_RegenerateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_regenerate(inputs)
	if (locale === "fr") return fr_salary_negotiate_regenerate(inputs)
	if (locale === "es") return es_salary_negotiate_regenerate(inputs)
	if (locale === "it") return it_salary_negotiate_regenerate(inputs)
	if (locale === "nl") return nl_salary_negotiate_regenerate(inputs)
	if (locale === "pl") return pl_salary_negotiate_regenerate(inputs)
	if (locale === "fi") return fi_salary_negotiate_regenerate(inputs)
	if (locale === "da") return da_salary_negotiate_regenerate(inputs)
	if (locale === "sv") return sv_salary_negotiate_regenerate(inputs)
	return en_salary_negotiate_regenerate(inputs)
});